exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Timeline__timelineWrapper___1mJnh {\n  display: none;\n}\n@media (min-width: 1024px) {\n  .Timeline__timelineWrapper___1mJnh {\n    display: block;\n    position: relative;\n    margin: 250px 0px;\n  }\n  .Timeline__timelineWrapper___1mJnh .Timeline__row___3jf9- {\n    align-items: center;\n    flex-wrap: nowrap;\n  }\n}\n.Timeline__timelineWrapper___1mJnh .Timeline__container___rbSQS {\n  max-width: 100%;\n}\n@media (min-width: 1500px) {\n  .Timeline__timelineWrapper___1mJnh .Timeline__container___rbSQS {\n    max-width: 1500px;\n  }\n}\n.Timeline__gradientLine___2sCk7 {\n  height: 2px;\n  width: 100%;\n  background: #007cf9;\n  position: absolute;\n  top: 11.5px;\n  z-index: -1;\n}\n.Timeline__circle___1c-pT {\n  border-radius: 50%;\n  background-color: #fff;\n  height: 10px;\n  width: 10px;\n  border: solid 2px #7395f4;\n  flex-basis: 1;\n  justify-content: center;\n  margin: 0 auto;\n}\n.Timeline__circle___1c-pT.Timeline__big___vrAyF {\n  height: 20px;\n  width: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"timelineWrapper": "Timeline__timelineWrapper___1mJnh",
	"row": "Timeline__row___3jf9-",
	"container": "Timeline__container___rbSQS",
	"gradientLine": "Timeline__gradientLine___2sCk7",
	"circle": "Timeline__circle___1c-pT",
	"big": "Timeline__big___vrAyF"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/stylus-loader!./src/components/timeline/Timeline.styl
// module id = 244
// module chunks = 0